import { OFFER_DRAFTS_CAPABILITY } from '@ooh/contracts';
import { useHasCapability } from '../../data/use-has-capability';
import { useEditableDraftsQuery } from './api/offer-drafts';
import { useLastUsedOfferDraftQuery } from './api/user-preferences';

/**
 * Drafts list and last-used preselection for the quick-add picker. The fetch is gated on the
 * `offer-drafts` capability and on `options.enabled` — locked-target call sites pass
 * `enabled: false` because the picker's list is unused when the destination offer is already pinned.
 */
export function useQuickAddPickerData(options?: { enabled?: boolean }) {
  const hasCapability = useHasCapability(OFFER_DRAFTS_CAPABILITY);
  const enabled = hasCapability && (options?.enabled ?? true);
  const { data: draftsData } = useEditableDraftsQuery({ enabled });
  const { data: lastUsedData } = useLastUsedOfferDraftQuery({ enabled });
  return { draftsData, lastUsedData };
}
